export default {
  getAdministrativePanelData: state => state.administrativePanelData,
  getFilaById: state => id => state.filas.find(fila => fila._id === id) || {},
}
